import { render, staticRenderFns } from "./ServiceOrdersGrid.vue?vue&type=template&id=4d4d9e0f&scoped=true"
import script from "./ServiceOrdersGrid.vue?vue&type=script&lang=js"
export * from "./ServiceOrdersGrid.vue?vue&type=script&lang=js"
import style0 from "./ServiceOrdersGrid.vue?vue&type=style&index=0&id=4d4d9e0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4d9e0f",
  null
  
)

export default component.exports